import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/img/xmark.svg'


const _hoisted_1 = {
  key: 0,
  class: "speech-detail-dialog"
}
const _hoisted_2 = {
  class: "speech-detail-dialog-container",
  ref: "container"
}
const _hoisted_3 = { class: "close-button" }
const _hoisted_4 = { class: "speech-list speech-list-sub-events" }
const _hoisted_5 = { class: "speech-title" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "speech-speakers"
}
const _hoisted_9 = {
  key: 0,
  class: "speaker-container"
}
const _hoisted_10 = { class: "speaker-list" }
const _hoisted_11 = { class: "speaker-header" }
const _hoisted_12 = ["set"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "speaker-position"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 2,
  class: "speaker-company"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = {
  key: 3,
  class: "speaker-country"
}
const _hoisted_20 = { class: "speaker-images" }
const _hoisted_21 = { class: "lazy-loading-component" }
const _hoisted_22 = ["onClick", "title"]
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = {
  key: 2,
  class: "speech-speakers speech-infos"
}
const _hoisted_25 = { class: "speaker-container" }
const _hoisted_26 = ["innerHTML"]
const _hoisted_27 = { class: "speaker-images" }
const _hoisted_28 = {
  key: 0,
  class: "speaker-images-role-container"
}
const _hoisted_29 = ["onClick", "title"]
const _hoisted_30 = { class: "speech-footer" }
const _hoisted_31 = { class: "speech-time-container" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = {
  key: 0,
  class: "speech-language"
}
const _hoisted_34 = {
  key: 2,
  class: "speech-translation"
}
const _hoisted_35 = {
  key: 3,
  class: "speech-logo"
}
const _hoisted_36 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lazy_load_container = _resolveComponent("lazy-load-container")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeDialog($event)))
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("img", { src: _imports_0 }, null, -1)
            ]))
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.speeches, (subSpeech) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "speech-info-container speech-info-container-sub-events",
                style: _normalizeStyle(_ctx.getBorderColorCSS(subSpeech))
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    _createTextVNode(_toDisplayString(subSpeech.title) + " ", 1),
                    (_ctx.enableFavorites)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass([_ctx.isFavorite(subSpeech) ? 'fas' : 'far', "fa-star"]),
                          onClick: ($event: any) => (_ctx.toggleFavorite(subSpeech, $event))
                        }, null, 10, _hoisted_7))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (!subSpeech.showInfoInsteadOfSpeakers())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (subSpeech.persons.length > 0)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.roles, (role) => {
                            return (_openBlock(), _createElementBlock(_Fragment, null, [
                              (subSpeech.hasSpeakerWithRole(role))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _createElementVNode("div", _hoisted_10, [
                                      _createElementVNode("span", _hoisted_11, _toDisplayString(subSpeech.getPersonsByRole(role).length > 1 ? role.displayNamePlural : role.displayNameSingular) + ": ", 1),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subSpeech.getPersonsByRole(role), (s) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          class: "speaker",
                                          set: (_ctx.speaker = _ctx.getSpeakerById(s.id))
                                        }, [
                                          (_ctx.speaker.displayName)
                                            ? (_openBlock(), _createElementBlock("span", {
                                                key: 0,
                                                class: "speaker-name",
                                                onClick: ($event: any) => (   _ctx.openSpeakerDetailDialog(_ctx.getSpeakerById(s.id), $event))
                                              }, [
                                                _createTextVNode(_toDisplayString(_ctx.speaker.displayName), 1),
                                                (_ctx.speaker.position || _ctx.speaker.company || _ctx.speaker.country)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, ","))
                                                  : _createCommentVNode("", true)
                                              ], 8, _hoisted_13))
                                            : _createCommentVNode("", true),
                                          (_ctx.speaker.position)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_15, [
                                                _createTextVNode(_toDisplayString(_ctx.speaker.position), 1),
                                                (_ctx.speaker.company || _ctx.speaker.country)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, ","))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.speaker.company)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                                                _createTextVNode(_toDisplayString(_ctx.speaker.company), 1),
                                                (_ctx.speaker.country)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, ","))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          (_ctx.speaker.country)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.speaker.country), 1))
                                            : _createCommentVNode("", true)
                                        ], 8, _hoisted_12))
                                      }), 256))
                                    ]),
                                    _createElementVNode("div", _hoisted_20, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subSpeech.getPersonsByRole(role), (s) => {
                                        return (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                          _createElementVNode("div", {
                                            onClick: ($event: any) => (_ctx.openSpeakerDetailDialog(_ctx.getSpeakerById(s.id), $event)),
                                            title: _ctx.getSpeakerById(s.id).displayName,
                                            style: _normalizeStyle([_ctx.getSpeakerById(s.id).hasPicture() ? {'background-image': 'url(' +_ctx.getSpeakerById(s.id).getPictureUrl() +')'} : {},  ])
                                          }, null, 12, _hoisted_22)
                                        ]))
                                      }), 256))
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 64))
                          }), 256))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (!subSpeech.showInfoInsteadOfSpeakers() && subSpeech.info !== undefined && subSpeech.info.length > 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: "speech-info",
                      innerHTML: subSpeech.info
                    }, null, 8, _hoisted_23))
                  : _createCommentVNode("", true),
                (subSpeech.showInfoInsteadOfSpeakers())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("div", _hoisted_25, [
                        _createElementVNode("div", {
                          class: "speaker-list",
                          innerHTML: subSpeech.info
                        }, null, 8, _hoisted_26),
                        _createElementVNode("div", _hoisted_27, [
                          (subSpeech.persons.length > 0)
                            ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.roles, (role, index) => {
                                return (_openBlock(), _createElementBlock(_Fragment, null, [
                                  (subSpeech.hasSpeakerWithRole(role))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subSpeech.getPersonsByRole(role), (s) => {
                                          return (_openBlock(), _createBlock(_component_lazy_load_container, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", {
                                                onClick: ($event: any) => (  _ctx.openSpeakerDetailDialog(_ctx.getSpeakerById(s.id), $event)),
                                                title: _ctx.getSpeakerById(s.id).displayName,
                                                style: _normalizeStyle([_ctx.getSpeakerById(s.id).hasPicture() ? {'background-image':'url(' +_ctx.getSpeakerById(s.id).getPictureUrl() +')'}: {}])
                                              }, null, 12, _hoisted_29)
                                            ]),
                                            _: 2
                                          }, 1024))
                                        }), 256))
                                      ]))
                                    : _createCommentVNode("", true)
                                ], 64))
                              }), 256))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("i", {
                      class: "fas fa-clock",
                      style: _normalizeStyle(_ctx.getIconColorCSS(subSpeech))
                    }, null, 4),
                    _createTextVNode(" " + _toDisplayString(subSpeech.timeSpan), 1)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.$haveMaps && subSpeech.stands.length > 0 ? 'speech-place' : ''),
                    onClick: ($event: any) => (_ctx.$haveMaps && subSpeech.stands.length > 0 ? _ctx.openStandDialog(subSpeech.stands[0], $event) : {})
                  }, [
                    _createElementVNode("i", {
                      class: "fas fa-map-marker-alt",
                      style: _normalizeStyle(_ctx.getIconColorCSS(subSpeech))
                    }, null, 4),
                    _createTextVNode(" " + _toDisplayString(subSpeech.place), 1)
                  ], 10, _hoisted_32),
                  (subSpeech.languageID)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                        _createElementVNode("i", {
                          class: "fas fa-comment-alt-lines",
                          style: _normalizeStyle(_ctx.getIconColorCSS(subSpeech))
                        }, null, 4),
                        _createTextVNode(" " + _toDisplayString(_ctx.getLangForSpeechById(subSpeech.languageID)), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (subSpeech.exhibitorName)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        class: "speech-exhibitor",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openExhibitorDialog(_ctx.speech.exhibitorId, $event)))
                      }, _toDisplayString(_ctx.$t("organizer")) + " " + _toDisplayString(subSpeech.exhibitorName), 1))
                    : _createCommentVNode("", true),
                  (subSpeech.hasTranslation)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                        _createElementVNode("i", {
                          class: "fas fa-headphones-alt",
                          style: _normalizeStyle(_ctx.getIconColorCSS(subSpeech))
                        }, null, 4),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("translate")), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (subSpeech.logo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.$t("organized-by")), 1),
                        _createVNode(_component_lazy_load_container, null, {
                          default: _withCtx(() => [
                            _createElementVNode("img", {
                              src: _ctx.speech.getLogoUrl()
                            }, null, 8, _hoisted_36)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true)
                ])
              ], 4))
            }), 256))
          ])
        ], 512)
      ]))
    : _createCommentVNode("", true)
}